
import React, { useState, useEffect, useRef } from "react";
import styles from "./css/Header.module.css";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { Paths } from "../routes/paths";
import { useAppSelector } from "../redux/store";
import { selectHasFeature } from "../redux/features";
import { FEATURES } from "../routes/features";

interface UserHeaderProps {
    name?: string;
}

export const UserHeader: React.FC<UserHeaderProps> = ({ name }) => {
    const navigate = useNavigate();
    const userFromStore = useSelector((state: any) => state.auth.user?.name || "משתמשת");
    const displayName = name || userFromStore;
    const [showMenu, setShowMenu] = useState(false);
    const menuRef = useRef<HTMLDivElement>(null);
    const canNavigatePackages = useAppSelector(selectHasFeature(FEATURES.PACKEGE));


    const handleLogout = () => {
        localStorage.clear();
        sessionStorage.clear();
        navigate("/");
    };

    const handleClickOutside = (event: MouseEvent) => {
        const target = event.target as HTMLElement;
        if (
            showMenu &&
            menuRef.current &&
            !menuRef.current.contains(target) &&
            !target.closest("#userButton")
        ) {
            setShowMenu(false);
        }
    };

    useEffect(() => {
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [showMenu]);


    return (
        <header className={styles.headerContainer}>
                
                    {/* <button
                        // className={styles.PackageButton}
                        onClick={() => {
                            setShowMenu(false);
                            navigate(`/${Paths.packages}`);
                        }}
                    >
                        <span className={styles.PackageButton}>חבילות</span>
                        חבילות
                    </button> */}

            <button
                id="userButton"
                className={styles.loginButton}
                onClick={() => setShowMenu(!showMenu)}
            >
                {displayName}
            </button>

            <div className={styles.centerContent}>
                <img
                    src="/Images/logoLetters.png"
                    alt="Forward Logo"
                    className={styles.logoImgLarge}
                />
            </div>

            {showMenu && (
                <div ref={menuRef} className={styles.profileMenuPopup}>
                    <button
                        className={styles.menuItem}
                        onClick={() => {
                            setShowMenu(false);
                            navigate(`/${Paths.analystArea}`);
                        }}
                    >
                        <span className={styles.menuIcon}>📋</span>
                        חזרה לרשימת המופלים
                    </button>

                    <button
                        className={styles.menuItem}
                        onClick={() => {
                            setShowMenu(false);
                            navigate(`/${Paths.analystProfile}`);
                        }}
                    >
                        <span className={styles.menuIcon}>👤</span>
                        פרופיל
                    </button>

                    <button
                        className={styles.menuItem}
                        onClick={() => {
                            setShowMenu(false);
                            navigate(`/${Paths.analystForms}`);
                        }}
                    >
                        <span className={styles.menuIcon}>📄</span>
                        טפסים
                    </button>

                    <button
                        className={styles.menuItem}
                        onClick={() => {
                            setShowMenu(false);
                            navigate(`/${Paths.packages}`);
                        }}
                    >
                        <span className={styles.menuIcon}>📦</span>
                        חבילות
                    </button>

                    <button
                        className={styles.logoutButton}
                        onClick={handleLogout}
                    >
                        <span className={styles.menuIcon}>↩️</span>
                        התנתק/י
                    </button>
                </div>
            )}
            <div className={styles.darkBar}></div>
        </header>
    );
};
